(function () {
  function initSlider(track) {
    var intervalSeconds = parseFloat(track.dataset.interval) || 3;
    var intervalMs = intervalSeconds * 1000;
    var itemsVisible = parseInt(track.dataset.items, 10) || 1;
    var totalSlides = track.children.length;
    var realCount = totalSlides / 3; // triplicamos la lista, así que esto son las categorías reales
    if (realCount <= 0) return;

    var viewport = track.closest('.category-slider-viewport');
    var dots = viewport ? viewport.querySelectorAll('[data-category-slider-dots] .category-slider-dot') : [];

    var slideWidth = 0; // ancho de UNA categoría (para pasos de autoplay)
    var setWidth = 0;   // ancho de UNA copia completa (para el wrap infinito)
    var autoplayTimer = null;
    var resumeTimer = null;
    var isJumping = false;
    var lastScrollLeft = 0;

    // Solo reaccionamos a cambios de scroll cuando sabemos que vienen
    // de verdad de un movimiento horizontal (tuyo o del auto-avance) —
    // así ignoramos los reinicios accidentales que a veces provoca el
    // navegador al cambiar de tamaño la pantalla visible (por scroll
    // vertical, ocultar la barra de direcciones, etc.).
    var allowScrollHandling = false;
    var activeTimeout = null;

    function markActive() {
      allowScrollHandling = true;
      if (activeTimeout) clearTimeout(activeTimeout);
      activeTimeout = setTimeout(function () {
        allowScrollHandling = false;
      }, 700);
    }

    function measureInitial() {
      slideWidth = track.clientWidth / itemsVisible;
      setWidth = track.scrollWidth / 3;
      // Arrancamos posicionados al inicio de la copia del MEDIO
      track.scrollLeft = setWidth;
      lastScrollLeft = setWidth;
    }

    // Se usa en cambios de tamaño posteriores (ej. rotar el celular).
    // A diferencia de measureInitial(), NO reinicia la posición a la
    // fuerza — el evento "resize" también se dispara solo por ocultarse
    // la barra de direcciones al hacer scroll vertical, y reiniciar ahí
    // rompía la animación. Solo ajusta si el ancho cambió de verdad,
    // manteniendo la posición relativa.
    function measureOnResize() {
      var oldSetWidth = setWidth;
      slideWidth = track.clientWidth / itemsVisible;
      var newSetWidth = track.scrollWidth / 3;

      if (oldSetWidth > 0 && newSetWidth > 0 && Math.abs(newSetWidth - oldSetWidth) > 2) {
        var ratio = track.scrollLeft / oldSetWidth;
        setWidth = newSetWidth;
        track.scrollLeft = ratio * setWidth;
        lastScrollLeft = track.scrollLeft;
      } else {
        setWidth = newSetWidth;
      }
    }

    function updateDots() {
      if (!dots.length || !slideWidth) return;
      var rawIndex = Math.round(track.scrollLeft / slideWidth);
      var realIndex = ((rawIndex % realCount) + realCount) % realCount;
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === realIndex);
      });
    }

    // Corrección INSTANTÁNEA: en cada evento de scroll (sin esperar a que
    // termine el gesto), si nos salimos de la copia del medio, saltamos
    // a la posición equivalente en la copia del medio, sin animación.
    // Esto evita cualquier espera, incluso deslizando muy rápido.
    //
    // PERO: si el cambio de scroll NO vino de un movimiento horizontal
    // genuino (marcado con markActive()), lo ignoramos y restauramos la
    // posición anterior — así un reinicio accidental del navegador
    // (por scroll vertical) no rompe la animación.
    track.addEventListener('scroll', function () {
      if (isJumping) return;

      if (!allowScrollHandling) {
        isJumping = true;
        track.scrollLeft = lastScrollLeft;
        isJumping = false;
        return;
      }

      if (track.scrollLeft >= setWidth * 2) {
        isJumping = true;
        track.scrollLeft -= setWidth;
        isJumping = false;
      } else if (track.scrollLeft <= 0) {
        isJumping = true;
        track.scrollLeft += setWidth;
        isJumping = false;
      }

      lastScrollLeft = track.scrollLeft;
      updateDots();
    }, { passive: true });

    function next() {
      markActive();
      track.scrollTo({ left: track.scrollLeft + slideWidth, behavior: 'smooth' });
    }

    function startAutoplay() {
      stopAutoplay();
      autoplayTimer = setInterval(next, intervalMs);
    }

    function stopAutoplay() {
      if (autoplayTimer) clearInterval(autoplayTimer);
      autoplayTimer = null;
    }

    function pauseAndScheduleResume() {
      stopAutoplay();
      if (resumeTimer) clearTimeout(resumeTimer);
      resumeTimer = setTimeout(startAutoplay, intervalMs + 1500);
    }

    // Distinguir TAP de ARRASTRE, y arrastre HORIZONTAL de deslizamiento VERTICAL.
    // Solo pausamos el auto-avance si el gesto es claramente horizontal;
    // un deslizamiento hacia arriba/abajo no debe detener el bucle.
    var startX = null, startY = null, didDrag = false, horizontalDragStarted = false;
    var DRAG_THRESHOLD = 8;

    track.addEventListener('pointerdown', function (e) {
      startX = e.clientX;
      startY = e.clientY;
      didDrag = false;
      horizontalDragStarted = false;
    }, { passive: true });

    track.addEventListener('pointermove', function (e) {
      if (startX === null) return;
      var dx = Math.abs(e.clientX - startX);
      var dy = Math.abs(e.clientY - startY);

      if (!horizontalDragStarted && (dx > DRAG_THRESHOLD || dy > DRAG_THRESHOLD)) {
        if (dx > dy) {
          horizontalDragStarted = true;
          didDrag = true;
          markActive();
          pauseAndScheduleResume();
        }
      } else if (horizontalDragStarted) {
        markActive();
      }
    }, { passive: true });

    ['pointerup', 'touchend', 'pointercancel'].forEach(function (evt) {
      track.addEventListener(evt, function () {
        if (horizontalDragStarted) {
          if (resumeTimer) clearTimeout(resumeTimer);
          resumeTimer = setTimeout(startAutoplay, intervalMs + 1500);
        }
      }, { passive: true });
    });

    Array.prototype.slice.call(track.children).forEach(function (slide) {
      slide.addEventListener('click', function (e) {
        if (didDrag) e.preventDefault();
      });
    });

    window.addEventListener('load', measureInitial);
    measureInitial();
    updateDots();
    startAutoplay();

    window.addEventListener('resize', measureOnResize);
  }

  function initAll() {
    document.querySelectorAll('[data-category-slider]').forEach(initSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var track = event.target.querySelector('[data-category-slider]');
    if (track) initSlider(track);
  });
})();
